import axios from 'axios';
import deepmerge from 'deepmerge';

import adminApi from '@/admin/services/bright_finder';
import baseApi from '@/shared/services/bright_finder';
import managerApi from '@/manager/services/bright_finder';
import organizationApi from '@/specialist/services/bright_finder';

// Global flag to indicate we're in the process of auto-logging out
// This is used to bypass navigation guards that would otherwise
// show confirmation dialogs during the logout process
window.isAutoLoggingOut = false;

axios.defaults.withCredentials = true;
axios.defaults.headers.get.Accept = 'application/json';
axios.defaults.headers.patch.Accept = 'application/json';
axios.defaults.headers.post.Accept = 'application/json';
axios.defaults.headers.post['Content-Type'] = 'application/json';
axios.defaults.headers.patch['Content-Type'] = 'application/json';
axios.defaults.headers.get['X-Location'] = window.location.href;
axios.defaults.headers.get['X-Site'] = window.PORTAL_BASE_URL || window.location.host;
axios.defaults.headers.patch['X-Site'] = window.PORTAL_BASE_URL || window.location.host;
axios.defaults.headers.post['X-Site'] = window.PORTAL_BASE_URL || window.location.host;

axios.interceptors.response.use(
  (response) => {
    // If the response is successful, just return it
    return response;
  },
  (error) => {
    // Handle errors globally
    if (error.response) {
      if (isExpectedHttpError(error)) {
        return Promise.reject(error);
      }
      // You can add custom error handling logic here
      console.error('Error Status:', error.response.status);
      // The request was made and the server responded with a status code
      console.trace('Error Response:', error.response.data);
      if (error.response.status === 401 && !window.location.pathname.includes('/password')) {
        // Session timeout - set flag to bypass navigation guards
        window.isAutoLoggingOut = true;
        // Clear beforeunload handler to prevent browser's "Leave site?" dialog
        window.onbeforeunload = null;
        // Reload page to redirect to login
        // Session timeout - reload page to redirect to login
        window.location.reload();
        // Return a promise that never resolves to prevent code from continuing
        // while the page reloads
        return new Promise(() => {});
      }
    } else if (error.request) {
      // The request was made but no response was received
      console.error('Error Request:', error.request);
    } else {
      // Something happened in setting up the request that triggered an Error
      console.error('Error Message:', error.message);
    }
    // Optionally, you can return a rejected promise to propagate the error
    return Promise.reject(error);
  },
);

const isExpectedHttpError = (error) => {
  if (!import.meta.env.TEST) return false;

  return global.expectedHttpErrors.some((expectedError) => {
    if (expectedError.status !== error.response.status) return false;
    if (expectedError.errors === undefined) return true;

    return JSON.stringify(expectedError.errors) === JSON.stringify(error.response.data?.errors);
  });
};

export default deepmerge.all([baseApi, managerApi, organizationApi, adminApi]);
